export default __webpack_public_path__ + "static/media/twitter30.a04dbd22.png";